import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Flex, Box } from '@zillow/constellation';
import React, { useState, useEffect } from 'react';
import { omitUndefined } from '../../utils/lodash.js';
import MortgagePageClassification from '../../utils/mortgagehelpers/MortgagePageClassification.js';
import CalculatorForm from '../CalculatorForm/CalculatorForm.js';
import LegalDisclosuresModal from '../LegalDisclosuresModal/LegalDisclosuresModal.js';
import { getMortgageRates } from '../LegalDisclosuresModal/constants.js';
import { FieldConfig, OPTIONS_LOAN_TYPE, CREDIT_SCORE_BUCKETS, OPTIONS_LTV, OPTIONS_TIMESPAN } from './MortgageRateTrends.utils.js';
import MortgageRateTrendsChart from './MortgageRateTrendsChart.js';
import MortgageRateTrendsFields from './MortgageRateTrendsFields.js';

var MortgageRateTrends = function MortgageRateTrends(_ref) {
  var _Object$assign;
  var defaultValues = _ref.defaultValues,
    editorMode = _ref.editorMode,
    pathName = _ref.pathName;
  var classification = new MortgagePageClassification(pathName ? pathName : '/mortgage-rates/');
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    rates = _useState2[0],
    setRates = _useState2[1];
  var finalDefaultValues = Object.assign((_Object$assign = {}, _Object$assign[FieldConfig.loanPurpose.name] = OPTIONS_LOAN_TYPE.Purchase, _Object$assign[FieldConfig.creditRating.name] = CREDIT_SCORE_BUCKETS.VeryHigh, _Object$assign[FieldConfig.Fixed30Year.name] = true, _Object$assign[FieldConfig.location.name] = 'United States', _Object$assign[FieldConfig.percentDown.name] = OPTIONS_LTV.Normal, _Object$assign[FieldConfig.timeSpan.name] = OPTIONS_TIMESPAN.OneYear, _Object$assign), omitUndefined(defaultValues));
  useEffect(function () {
    var fetchRates = function fetchRates() {
      return new Promise(function ($return, $error) {
        var response;
        var $Try_1_Post = function () {
          try {
            return $return();
          } catch ($boundEx) {
            return $error($boundEx);
          }
        };
        var $Try_1_Catch = function (error) {
          try {
            console.error('Error fetching mortgage rates:', error);
            return $Try_1_Post();
          } catch ($boundEx) {
            return $error($boundEx);
          }
        };
        try {
          return Promise.resolve(getMortgageRates(pathName)).then(function ($await_2) {
            try {
              response = $await_2;
              setRates(response);
              return $Try_1_Post();
            } catch ($boundEx) {
              return $Try_1_Catch($boundEx);
            }
          }, $Try_1_Catch);
        } catch (error) {
          $Try_1_Catch(error);
        }
      });
    };
    fetchRates();
  }, [pathName]);
  return /*#__PURE__*/React.createElement(CalculatorForm, {
    fieldStorageKey: "mortgageratetrendsfields",
    defaultValues: finalDefaultValues,
    editorMode: editorMode
  }, /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    flexDirection: {
      default: 'column',
      xxl: 'row'
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    marginRight: {
      xxl: 'xs'
    },
    order: {
      default: 2,
      xxl: 1
    }
  }, /*#__PURE__*/React.createElement(MortgageRateTrendsFields, null)), /*#__PURE__*/React.createElement(Flex, {
    tabindex: "0",
    flex: "1",
    order: {
      default: 1,
      xxl: 2
    },
    as: "figure",
    role: "group"
  }, /*#__PURE__*/React.createElement(MortgageRateTrendsChart, null))), /*#__PURE__*/React.createElement(Box, {
    sx: {
      marginTop: '$spacing.sm'
    }
  }, /*#__PURE__*/React.createElement(LegalDisclosuresModal, {
    classification: classification,
    rates: rates
  })));
};
var MortgageRateTrends$1 = MortgageRateTrends;

export { MortgageRateTrends$1 as default };
